"use client";

import type { FC } from "react";
import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/button";
import { AllFiltersTrigger, type AllFiltersProps } from "./all-filters-trigger";
import { filterCount } from "./filters";

export const AllFiltersButton: FC<AllFiltersProps & { className?: string }> = ({ className, ...props }) => {
  const count = filterCount(props.filters);

  return (
    <AllFiltersTrigger {...props}>
      <Button
        variant="secondary-white"
        size="s"
        className={className}
        icon={
          count > 0 ? (
            <span className="flex size-18 items-center justify-center rounded-circle bg-brand-blue text-10 font-medium text-neutral-white">
              {count}
            </span>
          ) : (
            <AdjustmentsHorizontalIcon className="size-18" />
          )
        }
      >
        All filters
      </Button>
    </AllFiltersTrigger>
  );
};
